import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d4a5ad3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "The Curriculum to The School Migration", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This tool will remove the selected users from The Curriculum space, add them to The School space, and migrate all their articles (Pink Sheets, Green Sheets, White Papers, Positioning Matrices & Misc) from The Curriculum to The School as well.", -1 /* HOISTED */))
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "table table-bordered fp-bs-migrate-users" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "UserID", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "UserName", -1 /* HOISTED */))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Users to migrate", -1 /* HOISTED */))
const _hoisted_12 = { class: "table table-bordered" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "UserID"),
    /*#__PURE__*/_createElementVNode("th", null, "UserName"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Remove")
  ])
], -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "99",
  style: {"text-align":"center"}
}, " No users selected ", -1 /* HOISTED */))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["vue-tl-admin-tools-section-fp-bs-migrate", { loading: _ctx.loading, 'users-loaded': (_ctx.users.length > 0) }])
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("th", null, [
              _createTextVNode(" Email "),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailFilter) = $event)),
                type: "text",
                placeholder: "Filter by Email"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.emailFilter]
              ]),
              _createTextVNode(),
              (_ctx.emailFilter)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.emailFilter = '';})
                  }, "X"))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("th", null, [
              _createTextVNode(" Name "),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nameFilter) = $event)),
                type: "text",
                placeholder: "Filter by Name"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.nameFilter]
              ]),
              _createTextVNode(),
              (_ctx.nameFilter)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.nameFilter = '';})
                  }, "X"))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.users.length <= 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                _createElementVNode("td", {
                  colspan: "99",
                  style: {"text-align":"center","cursor":"pointer"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.loadUsers && _ctx.loadUsers(...args)))
                }, " Click to load FP users. ")
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersFiltered, (user) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: user.UserID
            }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((user.IsSelected) = $event),
                  type: "checkbox"
                }, null, 8 /* PROPS */, _hoisted_9), [
                  [_vModelCheckbox, user.IsSelected]
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(user.UserID), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(user.UserName), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(user.Email), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(user.DisplayName), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    (_ctx.users.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenUsers, (user) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: user.UserID
                }, [
                  _hoisted_14,
                  _createElementVNode("td", null, _toDisplayString(user.UserID), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(user.UserName), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(user.Email), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(user.DisplayName), 1 /* TEXT */),
                  _createElementVNode("td", {
                    onClick: ($event: any) => {user.IsSelected = false;}
                  }, " X ", 8 /* PROPS */, _hoisted_15)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (_ctx.chosenUsers.length <= 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, _hoisted_18))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("button", {
            class: "btn",
            disabled: !_ctx.canSubmit,
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.canSubmit && _ctx.migrateUsers(_ctx.chosenUsers)), ["prevent"]))
          }, " Migrate selected users ", 8 /* PROPS */, _hoisted_19)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}